import { Tabs, TabsProps } from "antd";
import React, { useEffect, useState } from "react";
import DoctorLoginForm from "../../Components/Auth/DoctorLoginForm";

import LoginForm from "../../Components/Auth/LoginForm";
import useTranslator from "../../Hooks/useTranslator";
import { useLocation } from "react-router-dom";

const Login = (props: any) => {

  const { _t } = useTranslator();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState("0");

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Patient',
      children: <LoginForm />
    },
    {
      key: '2',
      label: 'Doctor',
      children: <DoctorLoginForm />
    }
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const hasType = searchParams.has("type");
    const hasMobile = searchParams.has("mobile");

    if (hasType && hasMobile) {
      const type = searchParams.get("type");
      if (type === "doctor") {
        setActiveIndex("2");
      } else {
        setActiveIndex("1");
      }
    } else {
      setActiveIndex("1");
    }
  }, [location.search]);

  return (
    <>
      <div className="formtitlebar">
        <h4>Welcome</h4>
        <p>Welcome! Please enter your details.</p>
      </div>
      {
        activeIndex != "0" ? <>
          <Tabs
            className="theme-tabs"
            defaultActiveKey={activeIndex}
            items={items}
          />
        </> : null
      }
    </>
  );
};

export default Login;
